import store from '../../../store'

export default {
  orderById: 222,
  elementType: 'UploadFileBox',
  baseElementType: 'UPLOADFILE',
  elementDesc: '文件上传题',
  type: 'uploadfilebox',
  // 是否可配置
  config: true,
  title: '文件上传题',
  tipsUploadFile: '点击或者拖拽上传',
  tipsMaxFilesCountError: '最多上传${n}个文件',
  tipsMaxFileSizeError: '单个文件大小不超过${n}M',
  tipsUploading: '上传中...',
  tipsUploadFailed: '上传失败',
  tipsFileTypeError: '文件类型只允许${n}',
  visibility: '0',
  toolbar: {
    config: false
  },
  paramInt01: '3',
  saveCb (data) {
    // 断点续答时初始化答案
    if (Array.isArray(data.answerList)) {
      this.value = data.answerList.map(answer =>{
        return {
          name: answer.otherAnswer,
          url: answer.answer,
          uid: answer.extendsData.uid,
          type: answer.extendsData.type
        }
      })
    } else {
      this.value = []
    }
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/UploadFileBox/config.js